/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Period_NextInputs */

const fr_period_next = /** @type {(inputs: Period_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période suivante`)
};

const en_period_next = /** @type {(inputs: Period_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next period`)
};

/**
* | output |
* | --- |
* | "Next period" |
*
* @param {Period_NextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const period_next = /** @type {((inputs?: Period_NextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Period_NextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_period_next(inputs)
	return en_period_next(inputs)
});